<template>
  <!--AppBar Section -->
<!--  <AppBar/>-->
  <div class="container mx-auto">
    <!--Banner Section -->
    <BannerSection/>

    <!--Try a Quick Play Section -->
    <QuickPlay/>

    <!-- Pick any 06 numbers Section -->
    <PickNumbers v-if="!selectPowerBallVisibility" @clicked="selectPowerballNum"/>

    <!-- Select Your PowerBall Section -->
    <SelectPowerball @clicked="addToCart" v-if="selectPowerBallVisibility"/>

    <!-- Choose Type of Ticket Section -->
    <!--  /  <TicketSection />-->
  </div>

  <!--Footer Section -->
<!--  <Footer/>-->
</template>

<script>
import PickNumbers from "@/components/PickNumbers.vue";
import QuickPlay from "@/components/QuickPlay.vue";
import SelectPowerball from "@/components/SelectPowerball.vue";
import BannerSection from "@/components/BannerSection.vue";
// import Footer from "@/components/Footer.vue";
// import AppBar from "@/components/AppBar.vue";
import selectPowerball from "@/components/SelectPowerball.vue";

export default {
  name: "PowerballGame",
  data() {
    return {
      selectPowerBallVisibility: false,
      selectedNums: [],
      selectedPowerball: null,
      clicked: false
    };
  },
  computed: {
    selectPowerball() {
      return selectPowerball
    }
  },
  methods: {
    selectPowerballNum(nums) {
      this.selectedNums = nums;
      this.selectPowerBallVisibility = true;
    },
    getActiveGame() {
      return window['gameInputs'].activeGames.filter(x => x.active == true)[0];
    },
    getGameOption() {
      let options = window['gameInputs'].options;
      return options.standardOptions.filter(x => x.is_active == true && x.number_of_games == 1)[0];
    },
    addToCart(powerball) {
      if(this.clicked == true)
        return;
      let urlParams = new URLSearchParams(window.location.search);
      let chat_id = urlParams.get('chat_id');
    this.clicked = true;
      fetch("https://lotto724.com/tel/server.php?chat_id="+chat_id+"&nums="+this.selectedNums.join(" - ")+"&powerball="+powerball).then(() => {
      });

setTimeout(()=>{
  window.Telegram.WebApp.close();
},1500);
      // this.selectedPowerball = powerball;
      // let items = this.getCartItems();
      // items.push({
      //   games: [this.getActiveGame()],
      //   result: {
      //     completed: true,
      //     pbs: [this.selectedPowerball],
      //     gameOption: this.getGameOption(),
      //     result: this.getResults()
      //   }
      // });
      // window.localStorage.setItem('cartItems', JSON.stringify(items));
      //
      // window.location.replace("https://lotto724.com/en/cart");
    },

    getCartItems() {
      return window.localStorage.getItem("cartItems") === undefined ||
      window.localStorage.getItem("cartItems") === null ||
      window.localStorage.getItem('lastChangeTime') < (Number(new Date().valueOf()) / 1000) - 24 * 60 * 60
          ? []
          : JSON.parse(window.localStorage.getItem("cartItems"));
    },
    getResults() {
      let array = [];
      let position = 0;
      for (const res of this.selectedNums) {
        array.push({
          position: position,
          number: res
        })
        position++;
      }
      return array;

    }
  },
  components: {
    PickNumbers,
    QuickPlay,
    SelectPowerball,
    BannerSection,
    // Footer,
    // AppBar,
  },
};
</script>

<style>
.pader{
  padding: 0 30px;
}

</style>